// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3HAc0","noInteraction":"EventWrapper_noInteraction__w93xU"};